
import { imageSrcSet, originalImage } from '@/utils/media';

export default {
  name: "ResponsivePicture",
  props: {
    imageAttributes: {
      type: Object,
      required: true,
    },
    isImgFullscreen: {
      type: Boolean,
      required: false,
      default: false
    },
    imgID: {
      type: String,
      required: false,
      default: ''
    },
    imgClass: {
      type: String,
      required: false,
      default: ''
    },
    baseHeightOverride: {
      type: Boolean,
      required: false,
      default: false
    },
    alt: {
      type: String,
      default: "Image"
    },
    caption: {
      type: String,
      required: false,
    },
  },
  computed: {
    imageSource() {
      return originalImage(this.imageAttributes).url;
    },
    srcSet() {
      return imageSrcSet(this.imageAttributes);
    },
  },
  mounted() {
    this.setupImageLoadedEvent();
  },
  methods: {
    setupImageLoadedEvent() {
      const imgElement = this.$el.querySelector('img');
      this.$imagesLoaded(imgElement, () => {
        this.$emit('image-loaded');
      });
    },
    getSizes() {
      // sizes="(max-width: 640px) 250px, 600px" if the screen size is smaller than 640px width -> serves 250px image;
      // if its larger -> serves the 600px
      if (this.isImgFullscreen) {
        return "(max-width: 320px) 250px," +
          "(max-width: 600px) 600px," +
          "(max-width: 1200px) 1000px," +
          "1920px";
      } else {
        return "(max-width: 640px) 250px," +
          "(max-width: 1240px) 600px," +
          "(max-width: 1920px) 1200px," +
          "1920px";
      }
    },
  }
}
